import React, { FC } from 'react';
import { StyledPracticeName } from './style';
import { Button } from 'styled';
import removeDatesAndHyphensFromString from 'utils/removeDatesAndHyphensFromString';

import useLanguage from 'hooks/useLanguage';

import { PracticeName as IPracticeName } from 'types';

interface PassedProps {
  practiceName: IPracticeName;
  buttonVariant: 'underline-black-xs' | 'hover-underline-black';
  typography: 'primary' | 'secondary';
}

type Props = PassedProps;

const PracticeName: FC<Props> = ({
  practiceName,
  buttonVariant,
  typography,
}) => {
  const Language = useLanguage();

  if (practiceName.link.url) {
    return (
      <StyledPracticeName
        as={Button}
        key={practiceName.name}
        ariaLabel={Language.t('Global.readMoreAriaLabel', {
          topic: practiceName.name,
        })}
        to={practiceName.link.url}
        variant={buttonVariant}
        label={removeDatesAndHyphensFromString(practiceName.name)}
        wrap={true}
        typography={typography}
        inline={true}
      />
    );
  } else {
    return (
      <StyledPracticeName typography={typography} key={practiceName.name}>
        {removeDatesAndHyphensFromString(practiceName.name)}
      </StyledPracticeName>
    );
  }
};

export default PracticeName;
